export default "__VITE_ASSET__Dn3Tr5Sr__"